import { UserLoginState } from "../reducers/LoginReducer";
import { ResponseObject } from "../models/ResponseObject";
import { AxiosConfig } from "./AxiosConfig";


const getUserProfile = async (
  idToken: string,
  sapSystem:string,
  userName:string,
  successCallback: (userPersonalData: UserLoginState) => void,
  errorCallback: (error: Error) => void
) => {
  const user = {
    "token":idToken,
    "username":userName,
    "sapSystem":sapSystem
  };
  
  try {
    const resp = await AxiosConfig.post("/Account/AuthenticateMASUser", user);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const validateVendorURLToken = async (
  token: string,
  successCallback: (userPersonalData: ResponseObject) => void,
  errorCallback: (error: Error) => void
) => {
 
  try {
    const resp = await AxiosConfig.post("Account/ValidateVendorURLToken",{"token":token});
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const validateVendorPinCode = async (
  pin: string,
  successCallback: (userPersonalData: ResponseObject) => void,
  errorCallback: (error: Error) => void
) => {
 
  try {
    const resp = await AxiosConfig.post("Account/ValidateVendorPinCode",{"PinCode":pin});
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};
// function getUserProfile(
//   idToken: string,
//   userName:string,
//   successCallback: (userPersonalData: UserLoginState) => void,
// errorCallback: (error: Error) => void) {
//   const user = {
//          "token":idToken,
//          "username":userName
//        };
//   return axios.post('/Account/AuthenticateMASUser', user)
//       .then(function (response) {
//         successCallback(response.data);
//       })
//       .catch(function (error) {
//         errorCallback(error);
//       });
// }

export const AuthenticationService = {
  getUserProfile,
  validateVendorURLToken,
  validateVendorPinCode
};


